module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-ongoing"
    }
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.campaigns,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(actions)",
      fn: function(row) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group",
            "aria-label": "Basic example"
          }
        }, [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#view_pairing_brief_detailed_modal"
          },
          on: {
            "click": function($event) {
              _vm.getCampaignDataToView(row.item.id);
              _vm.getRateCardDataToView(row.item.id, _vm.influencerID);
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), (_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-success",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.acceptInvite(row.item.pairingID)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.rejectCampaign(row.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e(), _vm._v(" "), (!_vm.buttonShowPairing(row.item.pairingStatus)) ? _c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "type": "button",
            "data-toggle": "modal",
            "data-target": "#view_post_modal"
          },
          on: {
            "click": function($event) {
              return _vm.getPostDataToView(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file"
        })]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "size": "md"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('view-pairing-brief-detailed-modal', {
    attrs: {
      "modalId": 'view_pairing_brief_detailed_modal',
      "campaignData": _vm.viewCampaignData,
      "rateCardData": _vm.viewRateCardData
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "modalId": 'view_post_modal',
      "campaignData": _vm.viewPostCampaignData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bff13ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignOngoing.vue
// module id = 2114
// module chunks = 0